// extracted by mini-css-extract-plugin
export var code = "CruiseExcursionsList-module--code--5960d";
export var columnAccessibility = "CruiseExcursionsList-module--column-accessibility--49341";
export var columnActivityLevel = "CruiseExcursionsList-module--column-activity-level--c3d3f";
export var columnIcons = "CruiseExcursionsList-module--column-icons--a209c";
export var columnName = "CruiseExcursionsList-module--column-name--1ed49";
export var columnNew = "CruiseExcursionsList-module--column-new--b3919";
export var columnViewMore = "CruiseExcursionsList-module--column-view-more--81e5e";
export var container = "CruiseExcursionsList-module--container--bf328";
export var iconNewInline = "CruiseExcursionsList-module--icon-new-inline--f50b9";
export var icons = "CruiseExcursionsList-module--icons--d1cc9";
export var sectionTitle = "CruiseExcursionsList-module--section-title--0acef";
export var sectionTitleContent = "CruiseExcursionsList-module--sectionTitleContent--69aa2";
export var shorexFareBadge = "CruiseExcursionsList-module--shorex-fare-badge--c56b3";
export var table = "CruiseExcursionsList-module--table--3759c";
export var title = "CruiseExcursionsList-module--title--82b22";